let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
import { updateDialogHtml } from '../core/dialog'
import scrollToTarget from '../core/scrollTo'
/**
 * handleVisitStep
 * @param stepIndex
 */
function handleVisitStep(stepIndex) {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        /**
         * Convert next & prev string to stepIndex
         */
        if (typeof stepIndex === 'string') {
          if (stepIndex === 'next') stepIndex = this.activeStep + 1
          else stepIndex = this.activeStep - 1
        }
        /**
         * Do completion if end of tour
         */
        if (stepIndex >= this.tourSteps.length) {
          yield this.finishTour(true, this.group)
          return
        }
        yield goToStep(this, stepIndex).catch(e => {
          return reject(e)
        })
        return resolve(true)
      })
    )
  })
}
/**
 * handleVisitNextStep
 */
function handleVisitNextStep() {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        const stepIndex = this.activeStep + 1
        try {
          yield this.visitStep(stepIndex)
        } catch (e) {
          return reject(e)
        }
        return resolve(true)
      })
    )
  })
}
/**
 * handleVisitPrevStep
 */
function handleVisitPrevStep() {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        const stepIndex = this.activeStep - 1
        try {
          yield this.visitStep(stepIndex)
        } catch (e) {
          return reject(e)
        }
        return resolve(true)
      })
    )
  })
}
/**
 * goToStep
 * @param tgInstance
 * @param stepIndex
 */
function goToStep(tgInstance, stepIndex) {
  return new Promise((resolve, bail) =>
    __awaiter(this, void 0, void 0, function*() {
      /**
       * Min/Max checks
       */
      // Ensure index stays in range of toursteps
      if (stepIndex >= tgInstance.tourSteps.length) {
        return bail('End of tour steps')
      }
      if (stepIndex < 0) {
        return bail('Start of tour steps')
      }
      /**
       * Check step data
       */
      const currentStepIndex = tgInstance.activeStep
      const currentStep = tgInstance.tourSteps[currentStepIndex]
      const nextStep = tgInstance.tourSteps[stepIndex]
      if (!nextStep || !currentStep) return bail('Step not found by index')
      /** Before callbacks **/
      // Before change callback - global
      if (
        tgInstance._globalBeforeChangeCallback &&
        stepIndex !== currentStepIndex
      ) {
        try {
          yield tgInstance._globalBeforeChangeCallback()
        } catch (e) {
          return bail(e)
        }
      }
      // Before leave callback on current step
      if (currentStep.beforeLeave) {
        try {
          yield currentStep.beforeLeave(currentStep, nextStep)
        } catch (e) {
          return bail(e)
        }
      }
      // Before enter callback for next pending step
      if (nextStep.beforeEnter) {
        try {
          yield nextStep.beforeEnter(currentStep, nextStep)
        } catch (e) {
          return bail(e)
        }
      }
      /**
       * Sanitize step target to HTMLElement
       */
      // If target is string, query element by selector
      if (typeof nextStep.target === 'string')
        tgInstance.tourSteps[stepIndex].target = document.querySelector(
          nextStep.target
        )
      // If target is empty or not found, set target to centered backdrop
      // if(!nextStep.target) tgInstance.tourSteps[stepIndex].target = document.body
      if (!nextStep.target || !tgInstance.tourSteps[stepIndex].target)
        tgInstance.tourSteps[stepIndex].target = document.body
      /** Set active step **/
      tgInstance.activeStep = Number(stepIndex)
      /**
       * Update tour guide HTML
       */
      yield updateDialogHtml(tgInstance).catch(e => {
        if (tgInstance.options.debug) console.warn(e)
        bail(e)
      })
      /**
       * Scroll to target
       */
      if (tgInstance.options.autoScroll && nextStep.target !== document.body)
        yield scrollToTarget(tgInstance, nextStep.target)
      /**
       * Update backdrop & dialog positions & display
       */
      yield tgInstance.updatePositions()
      /** After callbacks **/
      // After leave callback for current step
      if (currentStep.afterLeave)
        yield currentStep.afterLeave(currentStep, nextStep)
      // After enter callback for next pending step (now the active step)
      if (nextStep.afterEnter) yield nextStep.afterEnter(currentStep, nextStep)
      // After change callback - global
      if (
        tgInstance._globalAfterChangeCallback &&
        stepIndex !== currentStepIndex
      )
        yield tgInstance._globalAfterChangeCallback()
      return resolve(true)
    })
  )
}
export default handleVisitStep
export { goToStep, handleVisitNextStep, handleVisitPrevStep }
